import { AssignmentsLink } from './assignments-link';

export class DigiTrainerLink extends AssignmentsLink {
    //  TODO https://redmine.sofamedia.at/issues/20056
    // title = 'Trainingsansicht';
    title = 'Freies Üben';
    bypassCheck = true;
    digiTrainer = true;
}
